import { serializeSuperjson } from '@lib/superjson';
import type {
  CreateNewPartUserPriceQuoteLineBody,
  CreateNewPartUserPriceQuoteLineOutput,
  CreateNewPartUserPriceQuoteLineParams,
} from '@snap-types/actions/create-new-part-user-price-quote-line';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

export const [
  createNewPartUserPriceQuoteLine,
  useCreateNewPartUserPriceQuoteLineMutation,
] = injectMutation<
  CreateNewPartUserPriceQuoteLineParams & CreateNewPartUserPriceQuoteLineBody,
  CreateNewPartUserPriceQuoteLineOutput
>(
  `${QUOTE_BUILDER_SLICE_NAME}/createNewPartUserPriceQuoteLine`,
  ({ siteCode, snapQuoteUuid, snapQuoteVersionUuid, partId }) => ({
    url: buildSnapQuoteUrl(
      siteCode,
      snapQuoteUuid,
      'quote-lines/new-part-user-price',
    ),
    method: 'POST',
    body: serializeSuperjson({ partId, snapQuoteVersionUuid }),
  }),
);
